import { render, staticRenderFns } from "./ARIB.vue?vue&type=template&id=939cf0d0&scoped=true&"
import script from "./ARIB.vue?vue&type=script&lang=js&"
export * from "./ARIB.vue?vue&type=script&lang=js&"
import style0 from "./ARIB.vue?vue&type=style&index=0&id=939cf0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939cf0d0",
  null
  
)

export default component.exports